import analytics from 'utilitys/helpers/Analytics/analytics';

interface Props {
    category: string;
    action: string;
    label: string;
}

const useEventWithDimensions = () => {
    const sendEventWithDimensions = ({ category, action, label }: Props) => {
        const event = `${category} - ${action}`;
        const options = {
            metadata: label,
        };
        analytics.fullStoryTrack(event, options);
    };

    return { sendEventWithDimensions };
};

export default useEventWithDimensions;
